import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "login-from"
};
const _hoisted_3 = {
  class: "login-from"
};
const _hoisted_4 = {
  class: "login-check"
};
const _hoisted_5 = {
  class: "login_btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("dl", null, [_cache[4] || (_cache[4] = _createElementVNode("dt", null, [_createElementVNode("img", {
    src: "/static/login_u.png"
  })], -1)), _createElementVNode("dd", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.forminput.user_phone = $event),
    type: "tel",
    placeholder: "输入用户名"
  }, null, 512), [[_vModelText, $setup.forminput.user_phone]])])])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("dl", null, [_cache[5] || (_cache[5] = _createElementVNode("dt", null, [_createElementVNode("img", {
    src: "/static/login_p.png"
  })], -1)), _createElementVNode("dd", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.forminput.user_pwd = $event),
    type: "password",
    placeholder: "输入密码"
  }, null, 512), [[_vModelText, $setup.forminput.user_pwd]])])])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_checkbox, {
    modelValue: $setup.rePassword,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.rePassword = $event),
    "checked-color": "#03a954"
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("记住密码")])),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.user_login && $setup.user_login(...args))
  }, "立即登录")])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "copyright"
  }, [_createElementVNode("ul", null, [_createElementVNode("li", null, "CopyRight © 2025 上海韵德餐饮有限公司"), _createElementVNode("li", null, [_createElementVNode("a", {
    href: "http://beian.miit.gov.cn/",
    target: "_blank"
  }, "备案号：沪ICP备16038014号-3")])])], -1))], 64);
}